@if (isCollapsed) {
    <div class="help-section">
        <button mat-button (click)="openLinkZap()" class="">
            <div class="w-100 d-flex flex-row justify-content-between align-items-center">
                <img
                    src="../../../../assets/img/v2/whatsapp-logo-384.png"
                    class="help-icon"
                    width="32"
                    alt="WhatsApp"
                />
            </div>
        </button>
    </div>
} @else {
    <div class="help-section">
        <mat-card class="help-card" (click)="openLinkZap()">
            <mat-card-content class="help-card-content card">
                <div class="help-content">
                    <span class="help-title">{{ 'menu.sideCards.support.title' | transloco }}</span>
                    <span class="help-subtitle">{{ 'menu.sideCards.support.subtitle' | transloco }}</span>
                </div>

                <div class="d-flex flex-row mt-2">
                    <button mat-stroked-button (click)="openLinkZap()" class="help-button">
                        <div class="w-100 d-flex flex-row justify-content-between align-items-center">
                            <img
                                src="../../../../assets/img/v2/whatsapp-logo-384.png"
                                class="help-icon"
                                width="32"
                                alt="WhatsApp"
                            />
                            <div>
                                <span class="entre-contato-text ms-1">{{
                                    'menu.sideCards.support.button' | transloco
                                }}</span>
                            </div>
                        </div>
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
}
